const serviceCategories = [
  {
    icon: "ri-car-line",
    title: "Automobile Storage",
    description:
      "Secure, fully-alarmed indoor storage for passenger cars of all makes and models. Our indoor facilities protect your vehicle from weather, vandalism, and theft year-round. Flexible short-term and long-term options available.",
    image: "https://public.readdy.ai/ai/img_res/cd2decb0948df37d3606bc8385e0e9f5.jpg",
    features: ["All makes and models", "Short & long-term rates", "Fully alarmed facility", "Indoor, weather-protected"],
  },
  {
    icon: "ri-star-line",
    title: "Classic & Collector Cars",
    description:
      "Purpose-built indoor protection for collector-grade, vintage, and investment vehicles. Our climate-moderated indoor environment preserves paint, interiors, and rubber seals — exactly what rare automobiles require for long-term preservation.",
    image: "https://readdy.ai/api/search-image?query=row%20of%20classic%20cars%20parked%20inside%20large%20warehouse%20storage%20facility%20with%20high%20ceilings%2C%20industrial%20lighting%2C%20clean%20concrete%20floor%2C%20dark%20moody%20premium%20automobile%20collection%20editorial%20style&width=600&height=400&seq=svc003&orientation=landscape",
    features: ["Vintage & collector vehicles", "Climate-moderated interior", "Long-term preservation focus", "Trusted by Bay Area collectors"],
  },
  {
    icon: "ri-riding-line",
    title: "Motorcycle Storage",
    description:
      "Indoor motorcycle storage with full alarm protection. Ideal for seasonal riders, enthusiasts heading out of town, or owners of high-value bikes requiring professional secure indoor storage in San Rafael or Point Richmond.",
    image: "https://readdy.ai/api/search-image?query=vintage%20motorcycle%20stored%20in%20climate%20controlled%20indoor%20garage%20facility%20with%20polished%20floors%2C%20warm%20golden%20lighting%2C%20dark%20elegant%20atmosphere%2C%20premium%20vehicle%20storage%20editorial%20photography&width=600&height=400&seq=svc002&orientation=landscape",
    features: ["All motorcycle types", "Seasonal & long-term options", "Fully alarmed & secure", "Motorcycle transport available"],
  },
  {
    icon: "ri-home-3-line",
    title: "RV & Motorhome Storage",
    description:
      "Spacious indoor storage for RVs and motorhomes. Both facilities can accommodate large vehicles, keeping them protected from California sun, rain, and potential vandalism. Best rates available for long-term RV storage.",
    image: "https://readdy.ai/api/search-image?query=RV%20and%20boat%20stored%20inside%20large%20indoor%20warehouse%20storage%20facility%20with%20high%20ceilings%2C%20spacious%20clean%20concrete%20floor%2C%20industrial%20warm%20lighting%2C%20professional%20vehicle%20storage%20facility%20photography&width=600&height=400&seq=svc004&orientation=landscape",
    features: ["Large format capacity", "Long-term best rates", "Indoor full protection", "Easy drop-off by appointment"],
  },
  {
    icon: "ri-anchor-line",
    title: "Boat & Marine Storage",
    description:
      "Indoor boat storage for small to mid-size vessels. Keeping your boat stored indoors prevents hull damage, UV fading, and theft. Our Bay Area facilities are ideally situated near the water with convenient access for San Francisco and Marin boaters.",
    image: "https://readdy.ai/api/search-image?query=RV%20and%20boat%20stored%20inside%20large%20indoor%20warehouse%20storage%20facility%20with%20high%20ceilings%2C%20spacious%20clean%20concrete%20floor%2C%20industrial%20warm%20lighting%2C%20professional%20vehicle%20storage%20facility%20photography&width=600&height=400&seq=svc004&orientation=landscape",
    features: ["Small to mid-size vessels", "UV & weather protection", "Bay Area location advantage", "Flexible duration"],
  },
  {
    icon: "ri-truck-line",
    title: "Trucks, Equipment & Specialty",
    description:
      "Oversized vehicle and equipment storage including trucks, commercial vehicles, and specialty machinery. Contact us to confirm space availability for your specific vehicle dimensions. Both San Rafael and Point Richmond locations offer generous indoor square footage.",
    image: "https://readdy.ai/api/search-image?query=interior%20of%20premium%20clean%20indoor%20vehicle%20storage%20facility%20with%20high%20polished%20concrete%20floors%2C%20dramatic%20overhead%20industrial%20lighting%2C%20dark%20walls%2C%20multiple%20classic%20and%20exotic%20cars%20stored%20in%20neat%20rows%2C%20professional%20upscale%20automotive%20storage%20facility&width=900&height=700&seq=why001&orientation=portrait",
    features: ["Trucks & oversized vehicles", "Commercial equipment", "Specialty machinery", "By appointment — call to confirm"],
  },
];

export default function ServicesDetail() {
  const handleScroll = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="bg-[#0F0F0F] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
            Full Service Breakdown
          </p>
          <h2 className="font-serif text-white text-4xl lg:text-5xl font-bold mb-4">
            What We Store
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mb-6"></div>
          <p className="font-sans text-[#9A9A9A] text-base max-w-xl mx-auto leading-relaxed">
            From everyday automobiles to rare collector vehicles — Don Collins offers fully-alarmed indoor storage for virtually every vehicle type in the Bay Area.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
          {serviceCategories.map((svc) => (
            <div
              key={svc.title}
              className="group bg-charcoal-200 rounded-lg overflow-hidden border border-white/5 hover:border-gold/30 transition-all duration-300"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={svc.image}
                  alt={`${svc.title} at Don Collins`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-9 h-9 flex items-center justify-center bg-gold/10 rounded-lg">
                    <i className={`${svc.icon} text-lg text-gold`}></i>
                  </div>
                  <h3 className="font-serif text-white text-xl font-semibold">{svc.title}</h3>
                </div>
                <p className="font-sans text-[#9A9A9A] text-sm leading-relaxed mb-5">
                  {svc.description}
                </p>
                <ul className="space-y-2 mb-5">
                  {svc.features.map((f) => (
                    <li key={f} className="flex items-center gap-2">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-checkbox-circle-fill text-gold text-xs"></i>
                      </div>
                      <span className="font-sans text-xs text-[#B8B8B8]">{f}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={handleScroll}
                  className="font-sans text-gold text-sm flex items-center gap-2 hover:gap-3 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  Inquire Now
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Motorcycle Transport Highlight */}
        <div className="bg-charcoal-300 rounded-lg border border-gold/20 p-8 flex flex-col lg:flex-row items-center gap-8 mb-10">
          <div className="w-14 h-14 flex items-center justify-center bg-gold/10 rounded-full flex-shrink-0">
            <i className="ri-road-map-line text-gold text-2xl"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h3 className="font-serif text-white text-xl font-semibold mb-2">
              Motorcycle Road Service &amp; Transport
            </h3>
            <p className="font-sans text-[#9A9A9A] text-sm leading-relaxed">
              Broke down on the road? Don&apos;t stall or fall — but if you do, call. Jim Long offers motorcycle road service and transport throughout the Bay Area. We&apos;ll pick you up and get your bike safely stored or repaired.
            </p>
          </div>
          <a
            href="tel:4158464281"
            className="font-sans text-sm font-semibold border border-gold text-gold px-6 py-3 rounded hover:bg-gold hover:text-charcoal transition-all duration-200 cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            Call Jim: (415) 846-4281
          </a>
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={handleScroll}
            className="font-sans text-sm font-semibold bg-gold text-charcoal px-8 py-4 rounded tracking-wide hover:bg-gold-light transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Check Availability for Your Vehicle
          </button>
        </div>
      </div>
    </section>
  );
}
